module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-extent-container",
    on: {
      "click": _vm.setFullExtent
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd35a98"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/toolbar/fullExtent.vue
// module id = 20
// module chunks = 0